import { TgaStatus } from '../../API'
import { warn } from '../util/Log'

const tgaStatusLookup = (text: string) => {
  if (!!text) {
    switch (text) {
      case 'TGA Approved':
        return TgaStatus.TGA_APPROVED
    }
  }
  warn('NO MATCH FOUND for', text)
  return null
}

export default tgaStatusLookup
